export default __webpack_public_path__ + "static/media/protectors-unite.564909a3.mp4";